<template>
  <div class="clublink-staff-dashboard">
    <!-- Background Elements -->
    <div class="page-grid"></div>
    <div class="page-orb orb-1"></div>
    <div class="page-orb orb-2"></div>

    <!-- Top Navigation -->
    <div class="top-nav">
      <div class="nav-container">
        <div class="nav-brand" @click="$router.push('/')">
          <div class="nav-logo-icon">
            <svg width="18" height="18" viewBox="0 0 24 24" fill="none">
              <path d="M12 2L14.5 9H21.5L15.5 13.5L18 20.5L12 16L6 20.5L8.5 13.5L2.5 9H9.5L12 2Z" fill="#1a2e26"/>
            </svg>
          </div>
          <span>ClubLink SOFTWARE</span>
          <span class="nav-badge">STAFF</span>
        </div>

        <div class="nav-actions">
          <div class="nav-user" @click="showUserMenu = !showUserMenu">
            <div class="user-avatar">{{ initials }}</div>
            <svg width="16" height="16" viewBox="0 0 16 16" fill="none">
              <path d="M4 6L8 10L12 6" stroke="currentColor" stroke-width="2" stroke-linecap="round"/>
            </svg>
            <div v-if="showUserMenu" class="user-dropdown" @click.stop>
              <button @click="goToSettings">
                <svg width="18" height="18" viewBox="0 0 18 18" fill="none">
                  <path d="M9 9C10.6569 9 12 7.65685 12 6C12 4.34315 10.6569 3 9 3C7.34315 3 6 4.34315 6 6C6 7.65685 7.34315 9 9 9Z" stroke="currentColor" stroke-width="1.5"/>
                  <path d="M3.75 15C3.75 12.1005 6.10051 9.75 9 9.75C11.8995 9.75 14.25 12.1005 14.25 15" stroke="currentColor" stroke-width="1.5" stroke-linecap="round"/>
                </svg>
                <span>Profile</span>
              </button>
              <div class="dropdown-divider"></div>
              <button @click="logout">
                <svg width="18" height="18" viewBox="0 0 18 18" fill="none">
                  <path d="M6.75 15.75H3.75C3.35218 15.75 2.97064 15.592 2.68934 15.3107C2.40804 15.0294 2.25 14.6478 2.25 14.25V3.75C2.25 3.35218 2.40804 2.97064 2.68934 2.68934C2.97064 2.40804 3.35218 2.25 3.75 2.25H6.75M12 12.75L15.75 9M15.75 9L12 5.25M15.75 9H6.75" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                </svg>
                <span>Logout</span>
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Hero Section -->
    <section class="hero-section">
      <div class="hero-container">
        <div class="hero-content">
          <div class="hero-text">
            <h1 class="hero-title">
              Welcome back, <span class="hero-name">{{ displayName }}</span>
            </h1>
            <p class="hero-subtitle">
              Close deals faster with a focused, streamlined workflow.
            </p>
          </div>

          <div class="hero-actions">
            <button class="action-btn btn-primary" @click="goToOnboarding">
              <svg width="20" height="20" viewBox="0 0 20 20" fill="none">
                <path d="M10 5V15M5 10H15" stroke="currentColor" stroke-width="2" stroke-linecap="round"/>
              </svg>
              <span>Onboard New Club</span>
            </button>

            <button class="action-btn btn-secondary" @click="goToClubs">
              <svg width="20" height="20" viewBox="0 0 20 20" fill="none">
                <path d="M13 7C13 8.65685 11.6569 10 10 10C8.34315 10 7 8.65685 7 7C7 5.34315 8.34315 4 10 4C11.6569 4 13 5.34315 13 7Z" stroke="currentColor" stroke-width="1.5"/>
                <path d="M10 12C6.68629 12 4 14.6863 4 18H16C16 14.6863 13.3137 12 10 12Z" stroke="currentColor" stroke-width="1.5"/>
              </svg>
              <span>View Leads</span>
            </button>

            <button class="action-btn btn-secondary" @click="goToTemplates">
              <svg width="20" height="20" viewBox="0 0 20 20" fill="none">
                <path d="M4 4H16M4 8H16M4 12H16M4 16H10" stroke="currentColor" stroke-width="1.5" stroke-linecap="round"/>
              </svg>
              <span>Templates</span>
            </button>

            <button class="action-btn btn-secondary" @click="goToPayments">
              <svg width="20" height="20" viewBox="0 0 20 20" fill="none">
                <path d="M2 6C2 4.89543 2.89543 4 4 4H16C17.1046 4 18 4.89543 18 6V14C18 15.1046 17.1046 16 16 16H4C2.89543 16 2 15.1046 2 14V6Z" stroke="currentColor" stroke-width="1.5"/>
                <path d="M2 8H18" stroke="currentColor" stroke-width="1.5"/>
              </svg>
              <span>Payments</span>
            </button>

            <button class="action-btn btn-secondary" @click="goToBlog">
              <svg width="20" height="20" viewBox="0 0 24 24" fill="none">
                <path d="M9 5H7C5.89543 5 5 5.89543 5 7V19C5 20.1046 5.89543 21 7 21H17C18.1046 21 19 20.1046 19 19V7C19 5.89543 18.1046 5 17 5H15M9 5C9 6.10457 9.89543 7 11 7H13C14.1046 7 15 6.10457 15 5M9 5C9 3.89543 9.89543 3 11 3H13C14.1046 3 15 3.89543 15 5M9 12H15M9 16H13" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
              </svg>
              <span>Manage Blog</span>
            </button>
          </div>
        </div>
      </div>
    </section>

    <!-- Dashboard Content -->
    <div class="dashboard-container">
      <!-- KPI Row -->
      <div class="kpi-row">
        <div class="kpi-card card-gold">
          <div class="kpi-content">
            <div class="kpi-text">
              <div class="kpi-label">Active Clubs</div>
              <div class="kpi-value">{{ activeClubs }}</div>
              <div class="kpi-meta">Live from Firestore</div>
            </div>
            <div class="kpi-icon icon-gold">
              <svg width="32" height="32" viewBox="0 0 24 24" fill="none">
                <path d="M17 21V19C17 17.9391 16.5786 16.9217 15.8284 16.1716C15.0783 15.4214 14.0609 15 13 15H5C3.93913 15 2.92172 15.4214 2.17157 16.1716C1.42143 16.9217 1 17.9391 1 19V21M23 21V19C22.9993 18.1137 22.7044 17.2528 22.1614 16.5523C21.6184 15.8519 20.8581 15.3516 20 15.13M16 3.13C16.8604 3.3503 17.623 3.8507 18.1676 4.55231C18.7122 5.25392 19.0078 6.11683 19.0078 7.005C19.0078 7.89317 18.7122 8.75608 18.1676 9.45769C17.623 10.1593 16.8604 10.6597 16 10.88M13 7C13 9.20914 11.2091 11 9 11C6.79086 11 5 9.20914 5 7C5 4.79086 6.79086 3 9 3C11.2091 3 13 4.79086 13 7Z" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
              </svg>
            </div>
          </div>
        </div>

        <div class="kpi-card card-blue">
          <div class="kpi-content">
            <div class="kpi-text">
              <div class="kpi-label">Open Leads</div>
              <div class="kpi-value">{{ openLeads }}</div>
              <div class="kpi-meta">Live from Firestore</div>
            </div>
            <div class="kpi-icon icon-blue">
              <svg width="32" height="32" viewBox="0 0 24 24" fill="none">
                <path d="M16 21V5C16 3.89543 15.1046 3 14 3H10C8.89543 3 8 3.89543 8 5V21M4 7H20M6 21H18C19.1046 21 20 20.1046 20 19V9C20 7.89543 19.1046 7 18 7H6C4.89543 7 4 7.89543 4 9V19C4 20.1046 4.89543 21 6 21Z" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
              </svg>
            </div>
          </div>
        </div>

        <div class="pipeline-card">
          <div class="card-header">
            <div class="card-title">
              <svg width="24" height="24" viewBox="0 0 24 24" fill="none">
                <path d="M22 12H18L15 21L9 3L6 12H2" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
              </svg>
              <span>Club Pipeline Health (7 days)</span>
            </div>
            <div class="card-meta">new → contacted → qualified</div>
          </div>
          <div class="pipeline-charts">
            <div class="chart-section">
              <div class="chart-label">Inbound</div>
              <div class="chart-placeholder chart-gold">
                <div v-for="(val, i) in sparkInbound" :key="`inbound-${i}`" class="chart-bar" :style="{ height: Math.max(val * 10, 5) + '%' }"></div>
              </div>
              <div class="chart-total">{{ sparkInbound.reduce((a, b) => a + b, 0) }} total</div>
            </div>
            <div class="chart-section">
              <div class="chart-label">Progressing</div>
              <div class="chart-placeholder chart-blue">
                <div v-for="(val, i) in sparkProgress" :key="`progress-${i}`" class="chart-bar" :style="{ height: Math.max(val * 10, 5) + '%' }"></div>
              </div>
              <div class="chart-total">{{ sparkProgress.reduce((a, b) => a + b, 0) }} total</div>
            </div>
            <div class="chart-section">
              <div class="chart-label">Demos &amp; Proposals</div>
              <div class="chart-placeholder chart-green">
                <div v-for="(val, i) in sparkProposals" :key="`proposals-${i}`" class="chart-bar" :style="{ height: Math.max(val * 10, 5) + '%' }"></div>
              </div>
              <div class="chart-total">{{ sparkProposals.reduce((a, b) => a + b, 0) }} total</div>
            </div>
          </div>
        </div>
      </div>

      <!-- Second Row -->
      <div class="cards-row">
        <!-- Today's Focus -->
        <div class="focus-card">
          <div class="card-header">
            <div class="card-title">
              <svg width="24" height="24" viewBox="0 0 24 24" fill="none">
                <path d="M12 2L15.09 8.26L22 9.27L17 14.14L18.18 21.02L12 17.77L5.82 21.02L7 14.14L2 9.27L8.91 8.26L12 2Z" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
              </svg>
              <span>Today's Focus</span>
            </div>
            <div class="focus-progress">
              <svg class="progress-ring" width="40" height="40">
                <circle class="ring-bg" cx="20" cy="20" r="16" />
                <circle
                  class="ring-fill"
                  cx="20"
                  cy="20"
                  r="16"
                  :style="{ strokeDashoffset: progressOffset }"
                />
              </svg>
              <span class="progress-text">{{ Math.round(focusPercent) }}%</span>
            </div>
          </div>

          <div class="focus-list">
            <div
              v-for="item in focusList"
              :key="item.id"
              class="focus-item"
              @click="toggleFocus(item)"
            >
              <label class="focus-checkbox">
                <input type="checkbox" v-model="item.done" @click.stop />
                <span class="checkbox-mark"></span>
              </label>
              <div class="focus-content">
                <div class="focus-title" :class="{ done: item.done }">
                  {{ item.title }}
                </div>
                <div class="focus-subtitle">{{ item.sub }}</div>
              </div>
              <span v-if="item.badge" class="focus-badge">{{ item.badge }}</span>
            </div>
          </div>

          <div class="card-footer">
            <button class="footer-btn btn-gradient" @click="goToClubs">
              <svg width="16" height="16" viewBox="0 0 16 16" fill="none">
                <path d="M3.33334 5.33334L8.00001 8.00001L12.6667 5.33334M3.33334 10.6667L8.00001 13.3333L12.6667 10.6667M8.00001 2.66667L3.33334 5.33334L8.00001 8.00001L12.6667 5.33334L8.00001 2.66667Z" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
              </svg>
              <span>Jump to Leads</span>
            </button>
            <button class="footer-btn btn-text" @click="resetFocus">Reset</button>
          </div>
        </div>

        <!-- Team Leaderboard -->
        <div class="leaderboard-card">
          <div class="card-header">
            <div class="card-title">
              <svg width="24" height="24" viewBox="0 0 24 24" fill="none">
                <path d="M6 9H4.5C3.67157 9 3 9.67157 3 10.5V19.5C3 20.3284 3.67157 21 4.5 21H6M6 9V21M6 9H10M6 21H10M18 9H19.5C20.3284 9 21 9.67157 21 10.5V19.5C21 20.3284 20.3284 21 19.5 21H18M18 9V21M18 9H14M18 21H14M10 3H14V21H10V3Z" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
              </svg>
              <span>Team Leaderboard</span>
            </div>
            <div class="card-meta">motivates healthy competition</div>
          </div>

          <div v-if="!leaderboardLoading" class="leaderboard-list">
            <div
              v-for="(m, i) in leaderboard"
              :key="m.id"
              class="leaderboard-item"
            >
              <div class="leader-avatar" :class="getRankClass(i)">
                <span>{{ m.initials }}</span>
              </div>
              <div class="leader-info">
                <div class="leader-name">{{ m.name }}</div>
                <div class="leader-stats">{{ m.deals }} clubs signed • {{ m.points }} pts</div>
              </div>
              <div class="leader-rank" :class="getRankClass(i)">
                #{{ i + 1 }}
              </div>
            </div>
          </div>

          <div v-else class="loading-skeleton">
            <div v-for="i in 3" :key="i" class="skeleton-item"></div>
          </div>

          <div class="card-footer">
            <button class="footer-btn btn-text" @click="goToClubs">
              View pipeline →
            </button>
          </div>
        </div>
      </div>
    </div>

    <!-- Footer -->
    <footer class="footer-section">
      <div class="footer-content">
        © {{ new Date().getFullYear() }} ClubLink Software — All rights reserved.
      </div>
    </footer>
  </div>
</template>

<script setup>
import { ref, computed, onMounted, onBeforeUnmount } from 'vue'
import { auth, db } from '../firebase'
import router from '../router'
import {
  collection, onSnapshot, query, where, orderBy, limit, doc, getDoc,
  getCountFromServer, collectionGroup
} from 'firebase/firestore'

const displayName = ref('Staff Member')
const showUserMenu = ref(false)

const initials = computed(() => {
  const n = displayName.value.trim()
  if (!n || n === 'Staff Member') return 'SM'
  return n.split(/\s+/).map(p => p[0]).join('').slice(0, 2).toUpperCase()
})

/* ----- Header KPIs ----- */
const activeClubs = ref(0)
const openLeads = ref(0)
let unsubClubs, unsubLeads, unsubLeaderboard, unsubInbound, unsubInteractions, unsubNextActions

/* ===== Pipeline Health (dynamic) ===== */
const sparkInbound = ref([0, 0, 0, 0, 0, 0, 0])
const sparkProgress = ref([0, 0, 0, 0, 0, 0, 0])
const sparkProposals = ref([0, 0, 0, 0, 0, 0, 0])

function startOfDay(d) { const x = new Date(d); x.setHours(0, 0, 0, 0); return x }
function windowStart() { const t = new Date(); t.setDate(t.getDate() - 6); return startOfDay(t) }
function dayIdx(ts) {
  const start = windowStart().getTime()
  const date = ts?.seconds ? new Date(ts.seconds * 1000) : new Date(ts)
  const day = startOfDay(date).getTime()
  const i = Math.floor((day - start) / 86400000)
  return (i >= 0 && i < 7) ? i : -1
}
function empty7() { return [0, 0, 0, 0, 0, 0, 0] }

function subInbound() {
  const qRef = query(collection(db, 'leads'), where('createdAt', '>=', windowStart()))
  unsubInbound = onSnapshot(qRef, snap => {
    const buckets = empty7()
    snap.forEach(docu => { const i = dayIdx(docu.data().createdAt); if (i >= 0) buckets[i]++ })
    sparkInbound.value = buckets
  })
}

function subInteractions() {
  const qRef = query(collectionGroup(db, 'interactions'), where('at', '>=', windowStart()))
  unsubInteractions = onSnapshot(qRef, snap => {
    const buckets = empty7()
    snap.forEach(docu => { const i = dayIdx(docu.data().at); if (i >= 0) buckets[i]++ })
    sparkProgress.value = buckets
  })
}

function subNextActions() {
  const qRef = query(collection(db, 'leads'), where('nextAction.dueAt', '>=', windowStart()))
  unsubNextActions = onSnapshot(qRef, snap => {
    const buckets = empty7()
    snap.forEach(docu => {
      const d = docu.data()?.nextAction
      if (!d || !d.dueAt) return
      if (!['demo', 'proposal'].includes((d.type || '').toLowerCase())) return
      const i = dayIdx(d.dueAt); if (i >= 0) buckets[i]++
    })
    sparkProposals.value = buckets
  })
}

/* ===== Today's Focus ===== */
const focusList = ref([
  { id: 1, title: 'Call 3 new prospects', sub: 'Keep the pipeline warm', done: false, badge: 'Outbound' },
  { id: 2, title: 'Send 2 onboarding follow-ups', sub: 'Move clubs to qualified', done: false, badge: 'Follow-up' },
  { id: 3, title: 'Schedule 1 product demo', sub: 'Target high-intent clubs', done: false, badge: 'Demo' }
])
const focusPercent = ref(0)

const progressOffset = computed(() => {
  const circumference = 2 * Math.PI * 16
  return circumference - (focusPercent.value / 100) * circumference
})

const recalcFocus = () => {
  const total = focusList.value.length || 1
  const done = focusList.value.filter(x => x.done).length
  focusPercent.value = (done / total) * 100
}
const toggleFocus = (item) => { item.done = !item.done; recalcFocus() }
const resetFocus = () => { focusList.value.forEach(i => { i.done = false }); recalcFocus() }
recalcFocus()

/* ===== Team Leaderboard ===== */
const leaderboard = ref([])
const leaderboardLoading = ref(false)

const getRankClass = (index) => {
  if (index === 0) return 'rank-1'
  if (index === 1) return 'rank-2'
  if (index === 2) return 'rank-3'
  return 'rank-other'
}

const initialsFrom = (first, last, email) => {
  const n = `${first || ''} ${last || ''}`.trim()
  if (n) return n.split(/\s+/).map(p => p[0]).join('').slice(0, 2).toUpperCase()
  if (email) return email.replace(/@.*/, '').slice(0, 2).toUpperCase()
  return '??'
}

async function hydrateUserRow(uid, points) {
  const userSnap = await getDoc(doc(db, 'users', uid))
  const u = userSnap.exists() ? userSnap.data() : {}
  const name = (u.firstName || u.fullName || '').trim()
    ? `${u.firstName || ''} ${u.lastName || ''}`.trim() || u.fullName
    : (u.email || 'Unknown User')

  let deals = 0
  try {
    const wonQ = query(collection(db, 'leads'), where('ownerUid', '==', uid), where('status', '==', 'won'))
    const wonCount = await getCountFromServer(wonQ)
    deals = wonCount.data().count || 0
  } catch (_) { deals = 0 }

  return {
    id: uid,
    name,
    initials: initialsFrom(u.firstName, u.lastName, u.email),
    points: typeof points === 'number' ? points : (points?.toNumber?.() ?? 0),
    deals
  }
}

function subscribeLeaderboard() {
  const statsQ = query(collection(db, 'user_stats'), orderBy('points', 'desc'), limit(10))
  unsubLeaderboard = onSnapshot(statsQ, async (snap) => {
    leaderboardLoading.value = true
    const rows = await Promise.all(snap.docs.map(async d => {
      const data = d.data() || {}
      return hydrateUserRow(d.id, data.points ?? 0)
    }))
    leaderboard.value = rows
    leaderboardLoading.value = false
  }, () => { leaderboardLoading.value = false })
}

/* ===== Mount / Unmount ===== */
onMounted(() => {
  const user = auth.currentUser
  if (user) {
    getDoc(doc(db, 'users', user.uid)).then(snap => {
      if (snap.exists()) {
        const u = snap.data()
        const name = `${u.firstName || ''} ${u.lastName || ''}`.trim()
        displayName.value = name || u.fullName || u.email || 'Staff Member'
      }
    }).catch(() => {})
  }

  try {
    unsubClubs = onSnapshot(collection(db, 'customers'), snap => { activeClubs.value = snap.size })
    const openStatuses = ['new', 'contacted', 'qualified', 'proposal']
    unsubLeads = onSnapshot(query(collection(db, 'leads'), where('status', 'in', openStatuses)), snap => { openLeads.value = snap.size })

    subscribeLeaderboard()
    subInbound()
    subInteractions()
    subNextActions()
  } catch (e) {
    console.error('Firebase subscription error:', e)
  }
})

onBeforeUnmount(() => {
  unsubClubs?.(); unsubLeads?.(); unsubLeaderboard?.()
  unsubInbound?.(); unsubInteractions?.(); unsubNextActions?.()
})

/* ----- Nav/Auth ----- */
const logout = async () => {
  showUserMenu.value = false
  await auth.signOut()
  router.push('/login')
}
const goToSettings = () => {
  showUserMenu.value = false
  router.push('/staff-manage-settings')
}
const goToOnboarding = () => router.push('/staff-onboard-customer')
const goToClubs = () => router.push('/staff-leads')
const goToTemplates = () => router.push('/staff/templates')
const goToPayments = () => router.push('/staff-payments')
const goToBlog = () => router.push('/staff-blog')
</script>

<style scoped>
  @import url('https://fonts.googleapis.com/css2?family=Playfair+Display:wght@500;600;700&family=Montserrat:wght@400;500;600;700;800&display=swap');

  .clublink-staff-dashboard {
    --bg-page: #16241d;
    --bg-alt: #1c3128;
    --bg-card: #203a2f;
    --bg-card-hover: #274637;
    --border-subtle: rgba(255, 255, 255, 0.09);
    --border-gold: rgba(212, 175, 55, 0.35);
    --text-primary: #F5F6F4;
    --text-secondary: rgba(245, 246, 244, 0.68);
    --text-muted: rgba(245, 246, 244, 0.48);
    --gold: #d4af37;
    --gold-light: #e0c27a;
    --gold-dark: #a8862c;
    --blue: #5B8DBF;
    --blue-dark: #3D6690;
    --green: #4F8F6F;
    --green-dark: #386B52;

    min-height: 100vh;
    background: linear-gradient(160deg, #1a2e26 0%, #2d4a3e 55%, #16241d 100%);
    font-family: 'Montserrat', -apple-system, BlinkMacSystemFont, sans-serif;
    color: var(--text-primary);
    overflow-x: hidden;
  }

  .clublink-staff-dashboard .hero-title,
  .clublink-staff-dashboard .kpi-value,
  .clublink-staff-dashboard .leader-name {
    font-family: 'Playfair Display', 'Georgia', serif;
    letter-spacing: -0.01em;
  }

  /* ==================== BACKGROUND ELEMENTS ==================== */
  .page-grid {
    position: fixed;
    inset: 0;
    background-image:
      linear-gradient(to right, rgba(255, 255, 255, 0.05) 1px, transparent 1px),
      linear-gradient(to bottom, rgba(255, 255, 255, 0.05) 1px, transparent 1px);
    background-size: 60px 60px;
    mask-image: radial-gradient(ellipse 70% 60% at 50% 50%, black 20%, transparent 70%);
    pointer-events: none;
    z-index: 0;
  }

  .page-orb {
    position: fixed;
    border-radius: 50%;
    filter: blur(150px);
    opacity: 0.2;
    pointer-events: none;
    z-index: 0;
  }

  .orb-1 {
    width: 700px;
    height: 700px;
    background: radial-gradient(circle, rgba(212, 175, 55, 0.45), transparent);
    top: -280px;
    right: -280px;
  }

  .orb-2 {
    width: 600px;
    height: 600px;
    background: radial-gradient(circle, rgba(91, 141, 191, 0.28), transparent);
    bottom: -220px;
    left: -220px;
  }

  /* ==================== TOP NAVIGATION ==================== */
  .top-nav {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    z-index: 999;
    background: rgba(22, 36, 29, 0.9);
    backdrop-filter: blur(12px);
    border-bottom: 1px solid var(--border-subtle);
  }

  .nav-container {
    max-width: 1400px;
    margin: 0 auto;
    padding: 16px 24px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 32px;
  }

  .nav-brand {
    display: flex;
    align-items: center;
    gap: 12px;
    font-size: 14.5px;
    font-weight: 700;
    color: var(--text-primary);
    letter-spacing: 0.05em;
    cursor: pointer;
  }

  .nav-logo-icon {
    width: 32px;
    height: 32px;
    border-radius: 8px;
    background: linear-gradient(150deg, var(--gold-light) 0%, var(--gold) 55%, var(--gold-dark) 100%);
    display: flex;
    align-items: center;
    justify-content: center;
    transition: transform 0.3s ease;
  }

  .nav-brand:hover .nav-logo-icon {
    transform: rotate(180deg) scale(1.1);
  }

  .nav-badge {
    padding: 5px 14px;
    background: rgba(212, 175, 55, 0.12);
    border: 1px solid var(--border-gold);
    border-radius: 20px;
    font-size: 11px;
    font-weight: 700;
    letter-spacing: 0.1em;
    color: var(--gold-light);
  }

  .nav-actions {
    display: flex;
    align-items: center;
    gap: 12px;
  }

  .nav-user {
    display: flex;
    align-items: center;
    gap: 10px;
    padding: 6px 12px;
    background: rgba(255, 255, 255, 0.05);
    border: 1px solid var(--border-subtle);
    border-radius: 10px;
    color: var(--text-primary);
    cursor: pointer;
    transition: all 0.2s ease;
    position: relative;
  }

  .nav-user:hover {
    background: rgba(212, 175, 55, 0.08);
    border-color: var(--border-gold);
  }

  .user-avatar {
    width: 32px;
    height: 32px;
    border-radius: 50%;
    border: 2px solid var(--gold);
    background: linear-gradient(150deg, var(--gold-light), var(--gold-dark));
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 12px;
    font-weight: 800;
    color: #1a2e26;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.3);
  }

  .user-dropdown {
    position: absolute;
    top: calc(100% + 8px);
    right: 0;
    background: #1c3128;
    border: 1px solid var(--border-gold);
    border-radius: 12px;
    padding: 8px;
    min-width: 160px;
    box-shadow: 0 12px 36px rgba(0, 0, 0, 0.45);
    z-index: 1000;
  }

  .user-dropdown button {
    width: 100%;
    padding: 12px 16px;
    background: transparent;
    border: none;
    color: var(--text-secondary);
    font-size: 15px;
    font-weight: 500;
    text-align: left;
    cursor: pointer;
    border-radius: 8px;
    transition: all 0.2s ease;
    font-family: 'Montserrat', sans-serif;
    display: flex;
    align-items: center;
    gap: 10px;
  }

  .user-dropdown button:hover {
    background: rgba(212, 175, 55, 0.1);
    color: var(--gold-light);
  }

  /* ==================== HERO SECTION ==================== */
  .hero-section {
    position: relative;
    padding: 100px 0 60px;
    overflow: hidden;
  }

  .hero-container {
    max-width: 1400px;
    margin: 0 auto;
    padding: 0 24px;
    position: relative;
    z-index: 2;
  }

  .hero-content {
    display: flex;
    align-items: center;
    justify-content: space-between;
    flex-wrap: wrap;
    gap: 32px;
  }

  .hero-text {
    flex: 1;
    min-width: 300px;
  }

  .hero-title {
    font-size: clamp(32px, 5vw, 48px);
    font-weight: 600;
    color: var(--text-primary);
    margin-bottom: 16px;
    line-height: 1.2;
  }

  .hero-name {
    display: inline-block;
    color: var(--gold-light);
  }

  .hero-subtitle {
    font-size: 17px;
    line-height: 1.7;
    color: var(--text-secondary);
  }

  .hero-actions {
    display: flex;
    flex-wrap: wrap;
    gap: 14px;
  }

  .action-btn {
    display: inline-flex;
    align-items: center;
    gap: 10px;
    padding: 14px 24px;
    border: none;
    border-radius: 10px;
    font-family: 'Montserrat', sans-serif;
    font-size: 15px;
    font-weight: 600;
    cursor: pointer;
    transition: all 0.3s ease;
    white-space: nowrap;
  }

  .btn-primary {
    background: linear-gradient(150deg, var(--gold-light), var(--gold));
    color: #1a2e26;
    box-shadow: 0 4px 20px rgba(212, 175, 55, 0.3);
  }

  .btn-primary:hover {
    transform: translateY(-3px);
    box-shadow: 0 6px 24px rgba(212, 175, 55, 0.4);
  }

  .btn-secondary {
    background: rgba(255, 255, 255, 0.05);
    color: var(--text-primary);
    border: 1px solid var(--border-subtle);
  }

  .btn-secondary:hover {
    background: rgba(212, 175, 55, 0.08);
    border-color: var(--border-gold);
    transform: translateY(-2px);
  }

  /* ==================== DASHBOARD CONTAINER ==================== */
  .dashboard-container {
    max-width: 1400px;
    margin: -40px auto 0;
    padding: 0 24px 80px;
    position: relative;
    z-index: 3;
  }

  /* ==================== KPI ROW ==================== */
  .kpi-row {
    display: grid;
    grid-template-columns: repeat(auto-fit, minmax(320px, 1fr));
    gap: 28px;
    margin-bottom: 36px;
  }

  .kpi-card {
    background: var(--bg-card);
    border: 1px solid var(--border-subtle);
    border-radius: 16px;
    padding: 28px;
    transition: all 0.3s ease;
    position: relative;
    overflow: hidden;
  }

  .kpi-card:hover {
    transform: translateY(-6px);
    border-color: var(--border-gold);
    box-shadow: 0 12px 32px rgba(0, 0, 0, 0.35);
  }

  .card-gold {
    border-left: 4px solid var(--gold);
  }

  .card-blue {
    border-left: 4px solid var(--blue);
  }

  .kpi-content {
    display: flex;
    justify-content: space-between;
    align-items: center;
    position: relative;
    z-index: 1;
  }

  .kpi-text {
    flex: 1;
  }

  .kpi-label {
    font-size: 12px;
    font-weight: 700;
    text-transform: uppercase;
    letter-spacing: 0.1em;
    color: var(--text-muted);
    margin-bottom: 10px;
  }

  .kpi-value {
    font-size: 44px;
    font-weight: 700;
    color: var(--text-primary);
    line-height: 1;
    margin-bottom: 10px;
  }

  .kpi-meta {
    font-size: 13px;
    color: var(--text-secondary);
  }

  .kpi-icon {
    width: 68px;
    height: 68px;
    border-radius: 14px;
    display: flex;
    align-items: center;
    justify-content: center;
    transition: all 0.3s ease;
  }

  .icon-gold {
    background: linear-gradient(150deg, var(--gold-light), var(--gold));
    color: #1a2e26;
    box-shadow: 0 4px 20px rgba(212, 175, 55, 0.3);
  }

  .icon-blue {
    background: linear-gradient(135deg, var(--blue), var(--blue-dark));
    color: white;
    box-shadow: 0 4px 20px rgba(91, 141, 191, 0.3);
  }

  .kpi-card:hover .kpi-icon {
    transform: rotate(8deg) scale(1.15);
  }

  /* ==================== PIPELINE CARD ==================== */
  .pipeline-card {
    background: var(--bg-card);
    border: 1px solid var(--border-subtle);
    border-radius: 16px;
    padding: 28px;
    transition: all 0.3s ease;
    position: relative;
    overflow: hidden;
    border-left: 4px solid var(--green);
  }

  .pipeline-card:hover {
    transform: translateY(-6px);
    box-shadow: 0 12px 32px rgba(0, 0, 0, 0.35);
  }

  .card-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 28px;
    flex-wrap: wrap;
    gap: 12px;
    position: relative;
    z-index: 1;
  }

  .card-title {
    display: flex;
    align-items: center;
    gap: 12px;
    font-size: 18px;
    font-weight: 700;
    color: var(--text-primary);
  }

  .card-title svg {
    color: #6FA989;
  }

  .card-meta {
    font-size: 12px;
    color: var(--text-muted);
  }

  .pipeline-charts {
    display: grid;
    grid-template-columns: repeat(auto-fit, minmax(150px, 1fr));
    gap: 24px;
    position: relative;
    z-index: 1;
  }

  .chart-section {
    text-align: center;
  }

  .chart-label {
    font-size: 13px;
    font-weight: 700;
    color: var(--text-secondary);
    margin-bottom: 14px;
    text-transform: uppercase;
    letter-spacing: 0.05em;
  }

  .chart-placeholder {
    height: 100px;
    display: flex;
    align-items: flex-end;
    justify-content: space-around;
    gap: 6px;
    border-radius: 8px;
    padding: 12px 8px;
    background: var(--bg-alt);
    border: 1px solid var(--border-subtle);
  }

  .chart-bar {
    flex: 1;
    border-radius: 4px 4px 0 0;
    transition: all 0.3s ease;
    min-height: 5%;
    max-width: 20px;
  }

  .chart-placeholder:hover .chart-bar {
    filter: brightness(1.15);
  }

  .chart-gold {
    background: rgba(212, 175, 55, 0.05);
    border-color: rgba(212, 175, 55, 0.25);
  }

  .chart-gold .chart-bar {
    background: linear-gradient(to top, var(--gold-dark), var(--gold-light));
    box-shadow: 0 2px 8px rgba(212, 175, 55, 0.3);
  }

  .chart-blue {
    background: rgba(91, 141, 191, 0.05);
    border-color: rgba(91, 141, 191, 0.25);
  }

  .chart-blue .chart-bar {
    background: linear-gradient(to top, var(--blue-dark), var(--blue));
    box-shadow: 0 2px 8px rgba(91, 141, 191, 0.3);
  }

  .chart-green {
    background: rgba(79, 143, 111, 0.05);
    border-color: rgba(79, 143, 111, 0.25);
  }

  .chart-green .chart-bar {
    background: linear-gradient(to top, var(--green-dark), #6FA989);
    box-shadow: 0 2px 8px rgba(79, 143, 111, 0.3);
  }

  .chart-total {
    margin-top: 10px;
    font-size: 11px;
    font-weight: 700;
    color: var(--text-muted);
  }

  /* ==================== CARDS ROW ==================== */
  .cards-row {
    display: grid;
    grid-template-columns: repeat(auto-fit, minmax(450px, 1fr));
    gap: 28px;
  }

  /* ==================== FOCUS CARD ==================== */
  .focus-card {
    background: var(--bg-card);
    border: 1px solid var(--border-subtle);
    border-radius: 16px;
    padding: 28px;
    transition: all 0.3s ease;
    position: relative;
    overflow: hidden;
    border-left: 4px solid var(--green);
  }

  .focus-card:hover {
    transform: translateY(-6px);
    box-shadow: 0 12px 32px rgba(0, 0, 0, 0.35);
  }

  .focus-progress {
    position: relative;
    display: flex;
    align-items: center;
    justify-content: center;
  }

  .progress-ring {
    transform: rotate(-90deg);
  }

  .ring-bg {
    fill: none;
    stroke: var(--border-subtle);
    stroke-width: 4;
  }

  .ring-fill {
    fill: none;
    stroke: #6FA989;
    stroke-width: 4;
    stroke-linecap: round;
    stroke-dasharray: 100.53;
    transition: stroke-dashoffset 0.5s ease;
  }

  .progress-text {
    position: absolute;
    font-size: 13px;
    font-weight: 700;
    color: var(--text-primary);
  }

  .focus-list {
    margin: 28px 0;
    position: relative;
    z-index: 1;
  }

  .focus-item {
    display: flex;
    align-items: center;
    gap: 16px;
    padding: 18px;
    background: var(--bg-alt);
    border-radius: 12px;
    margin-bottom: 14px;
    cursor: pointer;
    transition: all 0.2s ease;
    border: 1px solid var(--border-subtle);
  }

  .focus-item:hover {
    background: var(--bg-card-hover);
    border-color: var(--border-gold);
    transform: translateX(6px);
  }

  .focus-checkbox {
    display: flex;
    align-items: center;
    cursor: pointer;
  }

  .focus-checkbox input[type="checkbox"] {
    display: none;
  }

  .checkbox-mark {
    width: 26px;
    height: 26px;
    border: 2px solid var(--gold);
    border-radius: 6px;
    display: flex;
    align-items: center;
    justify-content: center;
    transition: all 0.2s ease;
    flex-shrink: 0;
  }

  .focus-checkbox input[type="checkbox"]:checked + .checkbox-mark {
    background: var(--gold);
  }

  .focus-checkbox input[type="checkbox"]:checked + .checkbox-mark::after {
    content: '✓';
    color: #1a2e26;
    font-size: 18px;
    font-weight: 900;
  }

  .focus-content {
    flex: 1;
  }

  .focus-title {
    font-size: 16px;
    font-weight: 700;
    color: var(--text-primary);
    margin-bottom: 6px;
    transition: all 0.2s ease;
  }

  .focus-title.done {
    text-decoration: line-through;
    opacity: 0.5;
  }

  .focus-subtitle {
    font-size: 14px;
    color: var(--text-secondary);
  }

  .focus-badge {
    padding: 6px 14px;
    background: linear-gradient(150deg, var(--gold-light), var(--gold));
    border-radius: 20px;
    font-size: 11px;
    font-weight: 800;
    color: #1a2e26;
    text-transform: uppercase;
    letter-spacing: 0.05em;
    white-space: nowrap;
  }

  /* ==================== LEADERBOARD CARD ==================== */
  .leaderboard-card {
    background: var(--bg-card);
    border: 1px solid var(--border-subtle);
    border-radius: 16px;
    padding: 28px;
    transition: all 0.3s ease;
    position: relative;
    overflow: hidden;
    border-left: 4px solid var(--blue);
  }

  .leaderboard-card:hover {
    transform: translateY(-6px);
    box-shadow: 0 12px 32px rgba(0, 0, 0, 0.35);
  }

  .leaderboard-list {
    margin: 28px 0;
    position: relative;
    z-index: 1;
  }

  .leaderboard-item {
    display: flex;
    align-items: center;
    gap: 16px;
    padding: 14px;
    background: var(--bg-alt);
    border-radius: 12px;
    margin-bottom: 10px;
    transition: all 0.2s ease;
    border: 1px solid var(--border-subtle);
  }

  .leaderboard-item:hover {
    background: var(--bg-card-hover);
    border-color: var(--blue);
    transform: translateX(6px);
  }

  .leader-avatar {
    width: 44px;
    height: 44px;
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 15px;
    font-weight: 700;
    color: #ffffff;
    border: 3px solid;
    flex-shrink: 0;
  }

  .rank-1 {
    background: linear-gradient(150deg, var(--gold-light), var(--gold));
    border-color: var(--gold);
    color: #1a2e26;
    box-shadow: 0 4px 15px rgba(212, 175, 55, 0.35);
  }

  .rank-2 {
    background: linear-gradient(135deg, var(--blue), var(--blue-dark));
    border-color: var(--blue);
    box-shadow: 0 4px 15px rgba(91, 141, 191, 0.35);
  }

  .rank-3 {
    background: linear-gradient(135deg, var(--green), #6FA989);
    border-color: var(--green);
    box-shadow: 0 4px 15px rgba(79, 143, 111, 0.35);
  }

  .rank-other {
    background: var(--bg-alt);
    border-color: var(--border-subtle);
    color: var(--text-secondary);
  }

  .leader-info {
    flex: 1;
    min-width: 0;
  }

  .leader-name {
    font-size: 16px;
    font-weight: 700;
    color: var(--text-primary);
    margin-bottom: 6px;
  }

  .leader-stats {
    font-size: 13px;
    color: var(--text-muted);
  }

  .leader-rank {
    padding: 8px 16px;
    border-radius: 20px;
    font-size: 13px;
    font-weight: 700;
  }

  .loading-skeleton {
    padding: 28px 0;
  }

  .skeleton-item {
    height: 70px;
    background: linear-gradient(90deg, var(--bg-alt), var(--bg-card-hover), var(--bg-alt));
    background-size: 200% 100%;
    animation: skeleton-loading 1.5s ease-in-out infinite;
    border-radius: 12px;
    margin-bottom: 10px;
  }

  @keyframes skeleton-loading {
    0% { background-position: 200% 0; }
    100% { background-position: -200% 0; }
  }

  /* ==================== CARD FOOTER ==================== */
  .card-footer {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 14px;
    margin-top: 20px;
    padding-top: 20px;
    border-top: 1px solid var(--border-subtle);
    position: relative;
    z-index: 1;
  }

  .footer-btn {
    padding: 12px 20px;
    border: none;
    border-radius: 10px;
    font-family: 'Montserrat', sans-serif;
    font-size: 14px;
    font-weight: 600;
    cursor: pointer;
    transition: all 0.2s ease;
    display: flex;
    align-items: center;
    gap: 10px;
  }

  .btn-gradient {
    background: linear-gradient(150deg, var(--gold-light), var(--gold));
    color: #1a2e26;
    box-shadow: 0 4px 15px rgba(212, 175, 55, 0.25);
  }

  .btn-gradient:hover {
    transform: translateY(-2px);
    box-shadow: 0 6px 20px rgba(212, 175, 55, 0.35);
  }

  .btn-text {
    background: transparent;
    color: var(--gold-light);
  }

  .btn-text:hover {
    color: var(--gold);
    text-decoration: underline;
  }

  /* ==================== FOOTER ==================== */
  .footer-section {
    background: rgba(22, 36, 29, 0.5);
    border-top: 1px solid var(--border-subtle);
    padding: 24px 0;
    position: relative;
  }

  .footer-content {
    max-width: 1400px;
    margin: 0 auto;
    padding: 0 24px;
    text-align: center;
    color: var(--text-muted);
    font-size: 14px;
  }

  /* ==================== RESPONSIVE ==================== */
  @media (max-width: 960px) {
    .hero-content {
      flex-direction: column;
      align-items: flex-start;
    }

    .hero-actions {
      width: 100%;
      flex-direction: column;
    }

    .action-btn {
      width: 100%;
      justify-content: center;
    }

    .kpi-row,
    .cards-row {
      grid-template-columns: 1fr;
    }

    .pipeline-charts {
      grid-template-columns: 1fr;
    }
  }

  @media (max-width: 600px) {
    .dashboard-container {
      margin-top: -20px;
    }

    .kpi-card,
    .pipeline-card,
    .focus-card,
    .leaderboard-card {
      padding: 20px;
    }

    .hero-title {
      font-size: 32px;
    }

    .kpi-value {
      font-size: 36px;
    }
  }
</style>